<template>
    <rkm-row>
        <rkm-col cols="6">
            <rkm-form-input-autocomplete
                label="Profissional"
                v-model="model.avaliacao.usuario"
                :repository="this.repositories.usuario"
                :searchFields="fields.usuario"
                :requestQueryStringParams="autocompleteRequestParams.usuario"
                :validations="validations.usuario"
                :text-field="(item) => item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                placeholder="Digite o nome ou número do conselho profissional"
                :disabled="model.exportacao"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-select
                label="Unidade"
                :options="form.unidades"
                v-model="model.avaliacao.unidadeId"
                value-field="id"
                text-field="nomeFantasia"
                show-default-option
                :validations="validations.unidade"
                :disabled="model.exportacao"
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-select
                :options="form.infraestruturas"
                label="Local de atendimento"
                show-default-option
                text-field="nome"
                v-model="model.avaliacao.infraestruturaId"
                :validations="validations.infraestrutura"
                default-option-text="Selecione"
                value-field="id"
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-select
                label="Código da equipe"
                :options="form.equipes"
                v-model="model.avaliacao.equipeId"
                value-field="id"
                text-field="descricao"
                show-default-option
                :validations="validations.equipe"
                :disabled="model.exportacao"
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-select
                label="Ocupação"
                :options="form.ocupacoes"
                text-field="codigoNome"
                v-model="model.avaliacao.ocupacaoId"
                :validations="validations.ocupacao"
                value-field="id"
                show-default-option
                :disabled="model.exportacao"
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-select
                label="Turno"
                :options="form.turnos"
                value-field="id"
                text-field="nome"
                :validations="validations.turno"
                show-default-option
                v-model="model.turno"
                :disabled="model.exportacao"
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-date-picker
                label="Data"
                v-model="model.avaliacao.data"
                :validations="validations.data"
                :max-date="form.dataAtual"
                :disabled="model.exportacao"
                right
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-select
                label="Procedência"
                :options="form.procedencia"
                v-model="model.procedencia"
                value-field="id"
                text-field="descricao"
                disabled
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import { repository, object } from '@/mixins'
import { formats } from '@/mixins'
import { mapActions } from 'vuex'

export default {
    created() {
        this.repositories = {
            avaliacao: this.getConectaSusRepository('atencaoBasica.avaliacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
        }
        this.load()
    },
    data: () => ({
        enums: {
            permissao,
        },
    }),
    computed: {
        validations() {
            return {
                usuario: {
                    required: true
                },
                unidade: {
                    required: true
                },
                infraestrutura: {
                    required: true
                },
                equipe: {
                    required: true
                },
                ocupacao: {
                    required: true
                },
                turno: {
                    required: true
                },
                data: {
                    required: true
                }
            }
        },
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.AVALIACAO_ELEGIBILIDADE_ADMISSAO
                }
            }
        },
        fields() {
            return {
                usuario: [
                    { key: "cadastroCidadao.nome", searchable: true },
                    { key: "cadastroUsuario.registroNumero", searchable: true },
                ],

            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if(this.model.avaliacao.unidadeId) {
                this.getUnidades()
            }
            if(this.model.avaliacao.infraestruturaId) {
                this.getInfraestruturas()
            }
            if(this.model.avaliacao.equipeId) {
                this.getEquipes()
            }
            if(this.model.avaliacao.ocupacaoId) {
                this.getOcupacoes()
            }
        },
        getUnidades() {
            this.setLoading()
            this.repositories.avaliacao.getUnidades({
                usuario_id: this.model.avaliacao.usuario.id
            })
                .then(({ data }) => {
                    this.form.unidades = data
                    if(data.length === 1) {
                        this.model.avaliacao.unidadeId =  data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {

            this.setLoading()

            this.repositories.avaliacao.getInfraestruturas({
                usuario_id: this.model.avaliacao.usuario.id,
                unidade_id: this.model.avaliacao.unidadeId
            })
                .then(({ data }) => {

                    this.form.infraestruturas = data

                    if (data.length === 1) {
                        this.model.avaliacao.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {
            this.setLoading()
            this.repositories.avaliacao.getEquipes({
                usuario_id: this.model.avaliacao.usuario.id,
                infraestrutura_id: this.model.avaliacao.infraestruturaId
            })
                .then(({ data }) => {
                    this.form.equipes = data
                    if(data.length === 1) {
                        this.model.avaliacao.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {
            this.setLoading()
            this.repositories.avaliacao.getOcupacoes({
                usuario_id: this.model.avaliacao.usuario.id,
                infraestrutura_id: this.model.avaliacao.infraestruturaId
            })
                .then(({ data }) => {
                    this.form.ocupacoes = data
                    if(data.length === 1) {
                        this.model.avaliacao.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setCadastro(field) {

            if (field === 'usuario') {

                this.model.avaliacao.unidadeId = null
                this.model.avaliacao.infraestruturaId = null
                this.model.avaliacao.equipeId = null
                this.model.avaliacao.ocupacaoId = null
            } else if (field === 'unidade'){

                this.model.avaliacao.infraestruturaId = null
                this.model.avaliacao.equipeId = null
                this.model.avaliacao.ocupacaoId = null
            } else {

                this.model.avaliacao.equipeId = null
                this.model.avaliacao.ocupacaoId = null
            }
        }
    },
    watch: {
        'model.avaliacao.usuario': function (usuario) {
            if(usuario) {
                this.getUnidades()
            }

            this.setCadastro('usuario')
        },
        'model.avaliacao.unidadeId': function(unidade) {
            if(unidade) {
                this.getInfraestruturas()
            }

            this.setCadastro('unidade')
        },
        'model.avaliacao.infraestruturaId': function(infraestrutura) {
            if(infraestrutura) {
                this.getEquipes()
                this.getOcupacoes()
            }

            this.setCadastro('infraestrutura')
        }
    },
    mixins: [ repository, object, formats ],
    props: {
        model: { type: Object, required: false, },
        form: { type: Object, required: false, },
    },
}
</script>